import type React from 'react';

const ContentTitleSkeleton: React.FC = () => {
    return (
        <div className="flex flex-col space-y-8 animate-pulse-skeleton">
            <div className="rounded-4 w-1/2 h-[26px] bg-[var(--surface-color)]" />
            <div className="flex row space-x-8">
                <div className="rounded-4 w-[48px] h-[20px] bg-[var(--surface-color)]" />
                <div className="rounded-4 w-[48px] h-[20px] bg-[var(--surface-color)]" />
            </div>
        </div>
    );
};

export default ContentTitleSkeleton;
